'use client';

import { minutesRemainingFrom, useCurrentFlowStep } from '~/lib/flow-steps';

import { CheckIcon } from '@heroicons/react/20/solid';
import { cn } from '~/lib/utils';

export function SidebarSteps() {
  const match = useCurrentFlowStep();
  if (!match) return null;

  const { index: currentIndex, steps, step: currentStep } = match;
  const minutesLeft = minutesRemainingFrom(steps, currentIndex);
  const isConfirmation = currentStep.key === 'confirmation';

  return (
    <div className="flex flex-1 flex-col justify-between gap-y-8 py-10">
      <ol role="list" className="flex flex-col gap-y-4">
        {steps.map((step, i) => {
          const status =
            i < currentIndex
              ? 'complete'
              : i === currentIndex
                ? isConfirmation
                  ? 'complete'
                  : 'current'
                : 'pending';
          return (
            <li key={step.key} className="flex items-center gap-x-3">
              <StepIndicator status={status} />
              <span
                className={cn(
                  'font-mono text-xs font-semibold tracking-[0.12em] uppercase',
                  status === 'current' && 'text-white',
                  status === 'complete' && 'text-white/80',
                  status === 'pending' && 'text-[oklch(0.71_0.066_222.1)]'
                )}
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>

      {minutesLeft > 0 && (
        <p className="font-mono text-xs font-semibold tracking-[0.12em] text-[oklch(0.71_0.066_222.1)] uppercase">
          ~{minutesLeft} min left
        </p>
      )}
    </div>
  );
}

function StepIndicator({ status }: { status: 'complete' | 'current' | 'pending' }) {
  if (status === 'complete') {
    return (
      <div className="flex size-5 shrink-0 items-center justify-center rounded-full bg-accent">
        <CheckIcon className="size-3.5 text-brand-navy" aria-hidden="true" />
      </div>
    );
  }
  if (status === 'current') {
    return (
      <div className="flex size-5 shrink-0 items-center justify-center rounded-full border-2 border-accent ring-4 ring-accent/30">
        <span className="size-1.5 rounded-full bg-accent" />
      </div>
    );
  }
  return <div className="size-5 shrink-0 rounded-full border-2 border-white/20" />;
}
